import React, { useEffect, useRef, useState } from 'react';
import * as bootstrap from 'bootstrap';
import { API_BASE } from '../apiConfig';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
// import '../css/ContactUs.css';
import '../css/carrer.css';
// Modal is used via the namespace import above

const Careers = () => {
  const underlineRef = useRef(null);
  const jobDetailModalRef = useRef(null);
  const applyModalRef = useRef(null);
  const jobDetailModalInstanceRef = useRef(null);
  const applyModalInstanceRef = useRef(null);
  // const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [showApplyModal, setShowApplyModal] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formFields, setFormFields] = useState([]);
  const [formLoading, setFormLoading] = useState(false);
  const [formError, setFormError] = useState(null);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [formSuccess, setFormSuccess] = useState(null);
  const [formSubmitError, setFormSubmitError] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showLoaderModal, setShowLoaderModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [locationFilter, setLocationFilter] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');

  // Static form configuration for General Application
  const GENERAL_FIELDS = [
    { field_name: 'Full Name', field_type: 'text', required: 1 },
    { field_name: 'Email', field_type: 'email', required: 1 },
    { field_name: 'Phone', field_type: 'text', required: 1 },
    { field_name: 'Position of Interest', field_type: 'text', required: 0 },
    { field_name: 'Years of Experience', field_type: 'number', required: 0 },
    { field_name: 'Resume', field_type: 'file', required: 0 },
    { field_name: 'Notes', field_type: 'textarea', required: 0 }
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      if (underlineRef.current) {
        underlineRef.current.classList.add('animate');
      }
    }, 50);

    return () => clearTimeout(timer);
  }, []);
  
  const uniqueLocations = Array.from(new Set(jobs.map(j => j.location).filter(Boolean)));
  const uniqueCategories = Array.from(new Set(jobs.map(j => j.category || j.department).filter(Boolean)));
  
  const filteredJobs = jobs.filter(job => {
    const matchesSearch = searchTerm
      ? (
          (job.title && job.title.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (job.description && job.description.toLowerCase().includes(searchTerm.toLowerCase()))
        )
      : true;
    const matchesLocation = locationFilter ? job.location === locationFilter : true;
    const matchesCategory = categoryFilter ? (job.category || job.department) === categoryFilter : true;
    return matchesSearch && matchesLocation && matchesCategory;
  });
  console.log('jobs', jobs);
  useEffect(() => {
    fetch(`${API_BASE}/jobs`)
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch jobs');
        return res.json();
      })
      .then(data => {
        setJobs(data);
        setLoading(false);
      })
      .catch(err => {
        setError('Error fetching jobs: ' + err.message);
        setLoading(false);
      });
  }, []);

  const openJobModal = (job) => {
    setSelectedJob(job);
    const modalElement = jobDetailModalRef.current;
    if (modalElement) {
      if (jobDetailModalInstanceRef.current) {
        jobDetailModalInstanceRef.current.hide();
      }
      const instance = (bootstrap.Modal && typeof bootstrap.Modal.getOrCreateInstance === 'function')
        ? bootstrap.Modal.getOrCreateInstance(modalElement)
        : new bootstrap.Modal(modalElement, { keyboard: true, backdrop: true });
      jobDetailModalInstanceRef.current = instance;
      instance.show();
    }
  };

  const openApplyModal = (job) => {
    if (!job) return;
    setSelectedJob(job);
    setFormLoading(true);
    setFormError(null);
    setFormFields([]);
    // افتح المودال مباشرة
    const modalElement = applyModalRef.current;
    if (modalElement) {
      if (applyModalInstanceRef.current) {
        applyModalInstanceRef.current.hide();
      }
      const instance = (bootstrap.Modal && typeof bootstrap.Modal.getOrCreateInstance === 'function')
        ? bootstrap.Modal.getOrCreateInstance(modalElement)
        : new bootstrap.Modal(modalElement, { keyboard: true, backdrop: true });
      applyModalInstanceRef.current = instance;
      instance.show();
    }
    // If General Application, use static fields instead of API
    if (job.id === 0) {
      setFormFields(GENERAL_FIELDS);
      setFormLoading(false);
      return;
    }
    fetch(`${API_BASE}/job-form-fields/${job.id}`)
      .then(res => {
        if (!res.ok) throw new Error('Error fetching form fields');
        return res.json();
      })
      .then(data => {
        setFormFields(Array.isArray(data) ? data : []);
        setFormLoading(false);
      })
      .catch(() => {
        setFormError('Error fetching form fields');
        setFormLoading(false);
      });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setFormSubmitError(null);
    setFormSuccess(null);
  
    if (!selectedJob) return;
  
    const form = e.target;
    const data = {};
    let valid = true;
    let hasFile = false;
    const formData = new FormData();
  
    formFields.forEach(field => {
      const name = field.field_name;
      const required = field.required;
      const type = field.field_type;
      let value = '';
  
      if (type === 'file') {
        const fileObj = form[name]?.files?.[0];
        value = fileObj ? fileObj.name : '';
        if (fileObj) {
          formData.append(name, fileObj);
          hasFile = true;
        }
      } else if (type === 'radio') {
        const checked = form.querySelector(`input[name='${name}']:checked`);
        value = checked ? checked.value : '';
      } else {
        value = form[name]?.value || '';
      }
  
      if (required && !value) valid = false;
      data[name] = value;
    });
  
    if (!valid) {
      setFormSubmitError('Please fill all required fields');
      return;
    }
  
    setFormSubmitting(true);
  
    let fetchOptions;
    if (hasFile) {
      formData.append('job_id', selectedJob.id);
      formData.append('applicant_data', JSON.stringify(data));
      fetchOptions = {
        method: 'POST',
        body: formData
      };
    } else {
      fetchOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ job_id: selectedJob.id, applicant_data: data })
      };
    }
  
    fetch(`${API_BASE}/applications`, fetchOptions)
      .then(res => res.json())
      .then(resp => {
        if (resp.status === 'success') {
          setFormSuccess(null);
          setFormFields([]);
          setSelectedJob(null);
  
          closeApplyModal();
          
  
          // ✅ عرض اللودر ثم مودال النجاح
          setShowLoaderModal(true);
          setTimeout(() => {
            setShowLoaderModal(false);
            setSuccessMessage('Your application has been submitted successfully!');
            setShowSuccessModal(true);
  
            setTimeout(() => {
              setShowSuccessModal(false);
              setSuccessMessage('');
            }, 3000);
          }, 5000);
        } else {
          setFormSubmitError(resp.message || 'An error occurred while submitting');
        }
      })
      .catch(() => setFormSubmitError('An error occurred while submitting'))
      .finally(() => setFormSubmitting(false));
  };
  
  const closeApplyModal = () => {
    const el = applyModalRef.current;
    if (!el) return;
    const instance = (bootstrap.Modal && typeof bootstrap.Modal.getInstance === 'function')
      ? bootstrap.Modal.getInstance(el)
      : applyModalInstanceRef.current;
    const modal = instance || (bootstrap.Modal ? new bootstrap.Modal(el) : null);
    if (modal) {
      modal.hide();
      // Ensure cleanup after hidden
      const onHidden = () => {
        el.removeEventListener('hidden.bs.modal', onHidden);
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) backdrop.remove();
      };
      el.addEventListener('hidden.bs.modal', onHidden, { once: true });
    }
  };

  const closeJobDetailModal = () => {
    const el = jobDetailModalRef.current;
    if (!el) return;
    const instance = (bootstrap.Modal && typeof bootstrap.Modal.getInstance === 'function')
      ? bootstrap.Modal.getInstance(el)
      : jobDetailModalInstanceRef.current;
    
    if (instance) {
      instance.hide();
    } else if (bootstrap.Modal) {
      const modal = new bootstrap.Modal(el);
      modal.hide();
    }

    // Ensure cleanup after hidden
    const onHidden = () => {
      el.removeEventListener('hidden.bs.modal', onHidden);
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(b => b.remove());
    };
    el.addEventListener('hidden.bs.modal', onHidden, { once: true });
  };
  

  return (
    <>
      {/* Hero Section */}
      <div className="container-fluid about-bg9"> 
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-xl-6 about-text">
              <span className="about-subtitle">Join Our Vision</span>
              <h1 className="about-title text-white">Shaping the Future of Energy.</h1>
              <div className="about-underline animate" ref={underlineRef}></div>
              <p className="about-desc text-white">We're seeking passionate, driven individuals to join us in our mission to deliver excellence in Petrochoice Integrated Services.</p>
              <div className="mt-4">
                <a href="#positions" className="modern-btn-primary text-decoration-none">Explore Openings</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About/Benefits Section */}
      <div className="benefits-section">
        <div className="container">
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-8">
              <div className="row g-4">
                <div className="col-md-6">
                  <div className="benefit-card">
                    <div className="benefit-icon"><i className="bi bi-graph-up-arrow"></i></div>
                    <h4 className="benefit-title">Continuous Growth</h4>
                    <p className="text-muted mb-0">We invest in your development with ongoing training and clear career paths.</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="benefit-card">
                    <div className="benefit-icon"><i className="bi bi-shield-check"></i></div>
                    <h4 className="benefit-title">Impactful Projects</h4>
                    <p className="text-muted mb-0">Work on large-scale energy projects that make a real difference in the industry.</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="benefit-card">
                    <div className="benefit-icon"><i className="bi bi-people"></i></div>
                    <h4 className="benefit-title">Collaborative Culture</h4>
                    <p className="text-muted mb-0">Join a team of experts who value teamwork, diversity, and innovation.</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="benefit-card">
                    <div className="benefit-icon"><i className="bi bi-award"></i></div>
                    <h4 className="benefit-title">Competitive Rewards</h4>
                    <p className="text-muted mb-0">We offer comprehensive benefits and compensation that reflect your value.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="general-cta h-100 d-flex flex-column justify-content-center">
                <h3 className="fw-bold mb-3">Didn’t find a matching role?</h3>
                <p className="opacity-75 mb-4">We’re always looking for exceptional talent to join our pool. Send us your resume and we’ll reach out when the right opportunity arrives.</p>
                <button className="modern-btn-outline border-white text-white bg-transparent" onClick={() => openApplyModal({ id: 0, title: 'General Application' })}>
                  <i className="bi bi-file-earmark-person me-2"></i> General Application
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Job List */}
      <div className="container pb-5" id="positions">
        <div className="search-container">
          <div className="row g-3">
            <div className="col-md-6">
              <div className="input-group">
                <span className="input-group-text bg-transparent border-0 pe-0"><i className="bi bi-search text-muted"></i></span>
                <input
                  type="text"
                  className="form-control careers-input border-0 bg-transparent"
                  placeholder="Search by title or keywords..."
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <select className="form-select careers-input" value={locationFilter} onChange={e => setLocationFilter(e.target.value)}>
                <option value="">All Locations</option>
                {uniqueLocations.map(loc => (
                  <option key={loc} value={loc}>{loc}</option>
                ))}
              </select>
            </div>
            <div className="col-md-3">
              <select className="form-select careers-input" value={categoryFilter} onChange={e => setCategoryFilter(e.target.value)}>
                <option value="">All Categories</option>
                {uniqueCategories.map(cat => (
                  <option key={cat} value={cat}>{cat}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="text-center mt-5 mb-5">
          <h2 className="fw-bold display-6" style={{color:'#0f172a'}}>Open Positions</h2>
          <p className="text-muted">Discover your next career move with us.</p>
        </div>

        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : error ? (
          <div className="alert alert-danger text-center">{error}</div>
        ) : jobs.length === 0 ? (
          <div className="alert alert-info text-center">No job openings available at the moment.</div>
        ) : (
          <div className="row">
            {filteredJobs.map((job) => (
              <div className="col-md-6 col-lg-4 mb-4" key={job.id}>
                <div className="job-card" onClick={() => openJobModal(job)}>
                  <span className="job-badge">{job.category || job.department || 'General'}</span>
                  <h3 className="job-title">{job.title}</h3>
                  <p className="job-desc">
                    {job.description ? job.description.slice(0, 100) : ''}
                    {job.description && job.description.length > 100 ? '...' : ''}
                  </p>
                  
                  <div className="job-meta">
                    <div className="meta-item">
                      <i className="bi bi-geo-alt"></i>
                      {job.location}
                    </div>
                    <div className="meta-item">
                      <i className="bi bi-clock"></i>
                      {job.schedule || job.type || 'Full-time'}
                    </div>
                  </div>

                  <div className="d-flex gap-2 mt-auto">
                    <button className="modern-btn-outline flex-fill py-2" onClick={(e) => { e.stopPropagation(); openJobModal(job); }}>Details</button>
                    <button className="modern-btn-primary flex-fill py-2" onClick={(e) => { e.stopPropagation(); openApplyModal(job); }}>
                      <i className="bi bi-send me-1"></i> Apply
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Job Detail Modal */}
      <div className="modal fade modern-modal" id="jobDetailModal" tabIndex="-1" aria-hidden="true" ref={jobDetailModalRef}>
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            {selectedJob && (
              <>
                <div className="modal-header">
                  <div className="d-flex flex-column">
                    <h4 className="modal-title">{selectedJob.title}</h4>
                    <span className="modal-subtitle">Petrochoice Career Opportunity</span>
                  </div>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    onClick={closeJobDetailModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="job-info-grid">
                    <div className="job-info-card">
                      <span className="job-info-label">Category</span>
                      <span className="job-info-value">{selectedJob.category || 'General'}</span>
                    </div>
                    <div className="job-info-card">
                      <span className="job-info-label">Location</span>
                      <span className="job-info-value">{selectedJob.location}</span>
                    </div>
                    <div className="job-info-card">
                      <span className="job-info-label">Schedule</span>
                      <span className="job-info-value">{selectedJob.schedule || selectedJob.type || 'Full-time'}</span>
                    </div>
                    <div className="job-info-card">
                      <span className="job-info-label">Date Posted</span>
                      <span className="job-info-value">{selectedJob.date_posted || new Date(selectedJob.created_at).toLocaleDateString()}</span>
                    </div>
                  </div>

                  {selectedJob.description && (
                    <div className="mb-4">
                      <h5 className="section-title">
                        <i className="bi bi-info-circle me-1"></i> Job Description
                      </h5>
                      <div className="content-text">{selectedJob.description}</div>
                    </div>
                  )}

                  {selectedJob.responsibilities && (
                    <div className="mb-4">
                      <h5 className="section-title">
                        <i className="bi bi-list-check me-1"></i> Key Responsibilities
                      </h5>
                      <div className="content-text">{selectedJob.responsibilities}</div>
                    </div>
                  )}

                  {selectedJob.qualifications && (
                    <div className="mb-4">
                      <h5 className="section-title">
                        <i className="bi bi-mortarboard me-1"></i> Qualifications
                      </h5>
                      <div className="content-text">{selectedJob.qualifications}</div>
                    </div>
                  )}

                  {selectedJob.benefits && (
                    <div className="mb-4">
                      <h5 className="section-title">
                        <i className="bi bi-gift me-1"></i> Benefits & Perks
                      </h5>
                      <div className="content-text">{selectedJob.benefits}</div>
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                   <div className="job-modal-footer">
                      <button className="modern-btn-outline" data-bs-dismiss="modal" onClick={closeJobDetailModal}>Close</button>
                      <button 
                        className="modern-btn-primary"
                        onClick={() => {
                            closeJobDetailModal();
                            setTimeout(() => {
                               openApplyModal(selectedJob);
                             }, 300);
                        }}
                      >
                        Apply Now
                      </button>
                   </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Apply Modal */}
      <div className="modal fade modern-modal" id="applyModal" tabIndex="-1" aria-hidden="true" ref={applyModalRef}>
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleFormSubmit}>
              <div className="modal-header">
                <div className="d-flex flex-column">
                  <h5 className="modal-title">Application Form</h5>
                  <span className="modal-subtitle">Applying for <strong>{selectedJob?.title}</strong></span>
                </div>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                  onClick={closeApplyModal}
                ></button>
              </div>
              <div className="modal-body">
                {formSubmitError && (
                  <div className="alert alert-danger rounded-3 text-center mb-4">{formSubmitError}</div>
                )}
                {formLoading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2 text-muted">Preparing your form...</p>
                  </div>
                ) : formError ? (
                  <div className="alert alert-danger rounded-3 text-center">{formError}</div>
                ) : formFields.length === 0 ? (
                  <div className="alert alert-info rounded-3 text-center">No application form available for this job.</div>
                ) : (
                  <div className="row">
                    <div className="col-12">
                      <div className="form-section-header">
                        <i className="bi bi-person-badge"></i> Candidate Information
                      </div>
                    </div>
                    {formFields.map((field, idx) => {
                      const name = field.field_name;
                      const label = field.field_name;
                      const required = field.required;
                      const type = field.field_type;
                      let options = [];
                      if (field.options) {
                        if (Array.isArray(field.options)) {
                          options = field.options;
                        } else {
                          let opt = field.options;
                          if (typeof opt === 'string') {
                            if (opt.startsWith('"') && opt.endsWith('"')) opt = opt.slice(1, -1);
                            if (opt.startsWith('[') && !opt.endsWith(']')) opt = opt + ']';
                            opt = opt.replace(/\\\"/g, '"');
                            try {
                              const parsed = JSON.parse(opt);
                              options = Array.isArray(parsed) ? parsed : [];
                            } catch {
                              options = opt.split(',').map(s => s.replace(/"/g, '').trim());
                            }
                          }
                        }
                      }
                      
                      const isFullWidth = type === 'textarea' || type === 'file' || type === 'radio';
                      
                      // Add a section header for specific fields if needed
                      const showExperienceHeader = name.toLowerCase().includes('experience') && !formFields.slice(0, idx).some(f => f.field_name.toLowerCase().includes('experience'));
                      const showEducationHeader = name.toLowerCase().includes('education') && !formFields.slice(0, idx).some(f => f.field_name.toLowerCase().includes('education'));

                      return (
                        <React.Fragment key={idx}>
                          {(showExperienceHeader || showEducationHeader) && (
                            <div className="col-12">
                              <div className="form-section-header mt-4">
                                <i className={`bi bi-${showExperienceHeader ? 'briefcase' : 'mortarboard'}`}></i> {showExperienceHeader ? 'Professional Experience' : 'Educational Background'}
                              </div>
                            </div>
                          )}
                          <div className={isFullWidth ? "col-12 modern-form-group" : "col-md-6 modern-form-group"}>
                            <label className="modern-form-label">{label}{required ? ' *' : ''}</label>
                            {type === 'textarea' ? (
                              <textarea className="form-control modern-input" name={name} rows="4" required={!!required} placeholder={`Enter your ${label.toLowerCase()}...`}></textarea>
                            ) : type === 'select' || type === 'dropdown' ? (
                              <select className="form-select modern-input" name={name} required={!!required}>
                                <option value="" disabled selected>Select an option</option>
                                {options.map((opt, i) => (
                                  <option value={opt} key={i}>{opt}</option>
                                ))}
                              </select>
                            ) : type === 'radio' ? (
                              <div className="d-flex flex-wrap gap-2 mt-1">
                                {options.map((opt, i) => (
                                  <div className="form-check d-flex align-items-center" key={i}>
                                    <input className="form-check-input me-2" type="radio" name={name} id={name + '_' + i} value={opt} required={!!required} />
                                    <label className="form-check-label text-muted small" htmlFor={name + '_' + i}>{opt}</label>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <input type={type} className="form-control modern-input" name={name} required={!!required} placeholder={type === 'file' ? '' : `Type here...`} />
                            )}
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <div className="job-modal-footer">
                  <button type="button" className="modern-btn-outline" data-bs-dismiss="modal" disabled={formSubmitting} onClick={closeApplyModal}>Cancel</button>
                  <button type="submit" className="modern-btn-primary" disabled={formSubmitting}>
                    {formSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Submitting...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-send-fill me-2"></i> Submit Application
                      </>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Success Modal */}
      <div className={`modal fade modern-modal${showSuccessModal ? ' show' : ''}`} id="successModal" tabIndex="-1" aria-hidden={!showSuccessModal} style={{ display: showSuccessModal ? 'block' : 'none', background: 'rgba(0,0,0,0.5)', zIndex: 1060 }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center py-5">
              <div className="status-icon-box">
                <i className="bi bi-check2"></i>
              </div>
              <h3 className="fw-bold mb-2">Success!</h3>
              <p className="text-muted px-4 mb-4">{successMessage || 'Your application has been submitted successfully.'}</p>
              <button className="modern-btn-primary w-100" onClick={() => setShowSuccessModal(false)}>Great, Thanks!</button>
            </div>
          </div>
        </div>
      </div>

      {/* Loader Modal */}
      <div className={`modal fade modern-modal${showLoaderModal ? ' show' : ''}`} id="loaderModal" tabIndex="-1" aria-hidden={!showLoaderModal} style={{ display: showLoaderModal ? 'block' : 'none', background: 'rgba(0,0,0,0.5)', zIndex: 1060 }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center loader-container">
              <div className="spinner-border text-primary mb-4" style={{width:'4rem',height:'4rem', borderWidth: '0.25em'}} role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <h4 className="fw-bold">Submitting Application</h4>
              <p className="text-muted mb-0">Please wait while we process your request.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Careers;
